module.exports = __webpack_public_path__ + "static/services-corner-front_en.dc6232db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/services-corner-front_en.png
// module id = 438
// module chunks = 35783957827783